export default [
    { key: 'created_at', label: 'Fecha' },
    { key: 'user.name', label: 'Autor' },
    { key: 'person.name', label: 'Persona asociada' },
    { key: 'annotation_type.short_name', label: 'Tipo' },
    { key: 'content', label: 'Anotación' },
    { key: 'photos', label: 'Fotos', sortable: false },
]